// extracted by mini-css-extract-plugin
module.exports = {"nav":"navbar_nav__2rKp1","font":"navbar_font__2cJOv","other":"navbar_other__3_jLI","img":"navbar_img__2eE1E","networks":"navbar_networks__1Lm_1"};